import React from 'react';
import { useLocation } from 'react-router-dom';
import Picture from '@/image/hotel/monthly_book.jpg';

interface ImageData {
  src: string;
  title: string;
  text: string;
}

interface FeatureImageSliderProps {
  images: ImageData[];
}

export const FeatureImageSlider: React.FC<FeatureImageSliderProps> = ({
  images,
}) => {
  // URL の先頭セグメントから言語を判定（例: /en/... → en）
  const location = useLocation();
  const langSegment = location.pathname.split('/')[1];
  const isEnglish = langSegment === 'en';

  // 画像配列が空なら何も表示しない
  if (!images || images.length === 0) return null;

  // 表示する画像は1枚目のみ
  const mainImage = images[0];

  return (
    <div className="image-slider-container max-w-full overflow-hidden">
      {/* 見出し */}
      <div className="text-center mb-[72px] text-lg">(FEATURES)</div>

      {/* SP表示（md未満） */}
      <div className="block md:hidden">
        {/* 画像（1枚目のみ） */}
        <div className="w-full">
          <img
            src={mainImage.src}
            alt={mainImage.title}
            className="w-full h-auto object-cover"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = Picture;
            }}
          />
        </div>

        {/* テキストは配列の全要素を順番に表示 */}
        <div className="mt-4">
          {images.map((item, index) => (
            <div key={index} className="mb-6">
              <p className="font-bold text-base mb-1">{item.title}</p>
              <p className="text-sm">{item.text}</p>
            </div>
          ))}
        </div>

        {/* 最後に追加の文言を表示 */}
        <div className="mt-6 text-xs">
          {isEnglish
            ? "* No broker's fees required for standard Rental contracts"
            : '※ 通常の賃貸契約には仲介手数料は不要です'}
        </div>
      </div>

      {/* PC表示（md以上） */}
      <div className="hidden md:flex md:items-start md:gap-4 md:px-[100px]">
        {/* 左カラム: テキスト一覧 */}
        <div className="flex-1 flex flex-col space-y-6">
          {images.map((item, index) => (
            <div key={index}>
              <p className="text-base font-bold mb-2">{item.title}</p>
              <p className="text-sm">{item.text}</p>
            </div>
          ))}

          {/* 最後に追加の文言を表示 */}
          <div className="mt-6 text-xs">
            {isEnglish
              ? "* No broker's fees required for standard Rental contracts"
              : '※ 通常の賃貸契約には仲介手数料は不要です'}
          </div>
        </div>

        {/* 右カラム: 画像（1枚目のみ） */}
        <div className="flex-1 max-w-[494px]">
          <img
            src={mainImage.src}
            alt={mainImage.title}
            className="w-full max-h-[530px] h-auto object-cover"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = Picture;
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FeatureImageSlider;
